/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, IconButton, Menu, Typography } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { COLORS, SORT } from '../../constants/constants';
import _ from 'lodash';
import { ReactComponent as SortUpIcon } from '../../images/sort-up.svg';
import { ReactComponent as SortDownIcon } from '../../images/sort-down.svg';
import { i18n } from '../../i18n/i18n';
import { Tooltip, usePopup } from '@cellebrite/saas-ui-common';

interface Option {
    label: string;
    value?: string;
    default?: boolean;
    initialDirection?: any;
    tooltip?: any;
}

interface CustomSortableSelectionProps {
    namePrefix: string;
    options: Array<Option>;
    styles?: object;
    onChange: any;
    initialDirection?: any;
    directionClassName?: string;
    dropdownButtonClassName?: string;
}

const CustomSortableSelection: FC<CustomSortableSelectionProps> = ({
    namePrefix,
    options,
    styles,
    onChange,
    initialDirection,
    directionClassName,
    dropdownButtonClassName,
}) => {
    const [open, anchorEl, handleClick, handleClose] = usePopup(null, () => {});
    const selectedOptions = options.filter((option) => option.default);
    const [selectedOption, setSelectedOption] = useState(selectedOptions.length ? selectedOptions[0] : options[0]);
    const [direction, setDirection] = useState(initialDirection ? initialDirection : SORT.DIRECTION.DESC);

    const getTooltip = () => {
        let result =
            direction === SORT.DIRECTION.DESC
                ? i18n.translate('Highest to Lowest')
                : i18n.translate('Lowest to Highest');
        if (selectedOption.tooltip) {
            result = direction === SORT.DIRECTION.ASC ? selectedOption.tooltip.asc : selectedOption.tooltip.desc;
        }
        return result;
    };

    useEffect(() => {
        if (direction !== initialDirection) setDirection(initialDirection);
    }, [initialDirection]);

    return (
        <Box>
            <Button
                color="tetriary"
                onClick={open ? handleClose : handleClick}
                sx={{ backgroundColor: open ? COLORS.BRAND_LIGHTEST : null }}
                className={dropdownButtonClassName ? dropdownButtonClassName : ''}
            >
                <Typography
                    sx={{ mr: '2px', fontSize: '16px', fontWeight: '500', whiteSpace: 'nowrap' }}
                    className="color-bd"
                >
                    {namePrefix}
                </Typography>
                <Typography sx={{ fontSize: '16px', fontWeight: '500', whiteSpace: 'nowrap' }} className="color-md">
                    {` ${selectedOption.label}`}
                </Typography>
            </Button>
            <Tooltip placement="bottom-end" content={<Typography className="color-mh">{getTooltip()}</Typography>}>
                <IconButton
                    className={
                        directionClassName
                            ? directionClassName
                            : 'background-color-active-blst background-color-hover-mho fill-b'
                    }
                    onClick={() => {
                        const updateDirection =
                            direction === SORT.DIRECTION.DESC ? SORT.DIRECTION.ASC : SORT.DIRECTION.DESC;
                        setDirection(updateDirection);
                        onChange(updateDirection, selectedOption);
                    }}
                    disableRipple={true}
                >
                    {direction === SORT.DIRECTION.DESC ? <SortDownIcon /> : <SortUpIcon />}
                </IconButton>
            </Tooltip>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose} sx={{ borderRadius: '8px' }}>
                <Box sx={{ p: 1, ...styles }}>
                    {options.map((option) => {
                        return (
                            <Typography
                                key={option.label}
                                onClick={() => {
                                    if (option.initialDirection) {
                                        setDirection(option.initialDirection);
                                    }
                                    setSelectedOption(option);
                                    onChange(option.initialDirection ? option.initialDirection : direction, option);
                                    handleClose();
                                }}
                                className={`color-bd ${
                                    _.isEqual(selectedOption, option) ? 'background-color-blst' : ''
                                }`}
                                sx={{ py: 0.5, px: 1 }}
                            >
                                {option.label}
                            </Typography>
                        );
                    })}
                </Box>
            </Menu>
        </Box>
    );
};

export default CustomSortableSelection;
